import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'studio.oigsub',
    defaultMessage: 'Purchase subscription',
  },
  help: {
    id: 'studio.SENRqu',
    defaultMessage: 'Help',
  },
  subscription: {
    id: 'studio.R/6nsx',
    defaultMessage: 'Subscription',
  },
  billing: {
    id: 'studio.fIdgIs',
    defaultMessage: 'Billing information',
  },
  selectType: {
    id: 'studio.lUl1hr',
    defaultMessage: 'Select type of subscription',
  },
  year: {
    id: 'studio.IFo1oo',
    defaultMessage: 'Year',
  },
  month: {
    id: 'studio.TBovrx',
    defaultMessage: 'Month',
  },
  coupon: {
    id: 'studio.r0u4TP',
    defaultMessage: 'Coupon code',
  },
  subscriptionPrice: {
    id: 'studio.YmLeuv',
    defaultMessage: 'Total subscription price',
  },
  couponDiscount: {
    id: 'studio.vHYgoO',
    defaultMessage: 'Coupon discount',
  },
  activeSubscriptionDiscount: {
    id: 'studio.gqCPGf',
    defaultMessage: 'Active subscription discount',
  },
  couponCodeInvalid: {
    id: 'studio.rDvmAt',
    defaultMessage: 'Coupon code is invalid.',
  },
  vat: {
    id: 'studio.KxG+iy',
    defaultMessage: 'VAT',
  },
  total: {
    id: 'studio.MJ2jZQ',
    defaultMessage: 'Total',
  },
  checkout: {
    id: 'studio.BJ2TKX',
    defaultMessage: 'Checkout',
  },
  descriptionVatIdNumber: {
    defaultMessage: 'Your VAT id number.',
    id: 'studio.+NUiCV',
  },
  vatIdNumber: {
    defaultMessage: 'VAT id number',
    id: 'studio.5Y4+LR',
  },
  descriptionStreetName: {
    id: 'studio.oGJyuC',
    defaultMessage: 'Street name that will be used for invoicing.',
  },
  streetName: {
    id: 'studio.WrhuAL',
    defaultMessage: 'Street name',
  },
  descriptionHouseNumber: {
    id: 'studio.dLb8Qw',
    defaultMessage: 'House number that will be used for invoicing.',
  },
  houseNumber: {
    id: 'studio.GyoFyL',
    defaultMessage: 'House number',
  },
  descriptionCity: {
    id: 'studio.+R3lK1',
    defaultMessage: 'City that will be used for invoicing.',
  },
  city: {
    id: 'studio.TE4fIS',
    defaultMessage: 'City',
  },
  descriptionZipCode: {
    id: 'studio.Vo8m5X',
    defaultMessage: 'Zip code that will be used for invoicing.',
  },
  zipCode: {
    id: 'studio.2gnKy+',
    defaultMessage: 'Zip code',
  },
  selectCountry: {
    id: 'studio.EEdOfh',
    defaultMessage: 'Select a country',
  },
  descriptionCountry: {
    id: 'studio.pOPPD9',
    defaultMessage: 'Country that will be used for invoicing.',
  },
  country: {
    id: 'studio.vONi+O',
    defaultMessage: 'Country',
  },
  descriptionName: {
    id: 'studio.Hn/JYB',
    defaultMessage:
      'Company name that will be printed on the invoice and is displayed within Appsemble.',
  },
  name: {
    id: 'studio.HAlOn1',
    defaultMessage: 'Name',
  },
  descriptionInvoiceReference: {
    defaultMessage: 'Reference that will be shown on invoices.',
    id: 'studio.IZqJT1',
  },
  invoiceReference: {
    defaultMessage: 'Invoice reference',
    id: 'studio.u8z2PJ',
  },
  submit: {
    id: 'studio.acrOoz',
    defaultMessage: 'Continue',
  },
  confirmPaymentDetails: {
    id: 'studio.Qb3uSJ',
    defaultMessage: 'Confirm details',
  },
  paymentPending: {
    id: 'studio.WMDTol',
    defaultMessage: 'Payment is pending, please wait.',
  },
  paymentFailed: {
    id: 'studio.CNLAUH',
    defaultMessage: 'Payment has failed, please try again.',
  },
  paymentSucceeded: {
    id: 'studio.x5MHZT',
    defaultMessage:
      'Payment has been received and your subscription is active. Your invoice will be delivered via provided email.',
  },
  activate: {
    id: 'studio.AcxDgz',
    defaultMessage: 'Activate',
  },
  activeSubscriptionHelp: {
    id: 'studio.8boHh1',
    defaultMessage:
      'Since you currently have an active subscription, a discount will automatically be applied for the first payment term.',
  },
  discount: {
    id: 'studio.28C0Aj',
    defaultMessage: 'Discount',
  },
  sepaDebit: {
    id: 'studio.mHJuzW',
    defaultMessage: 'Sepa debit',
  },
  creditCard: {
    id: 'studio.kvOMtB',
    defaultMessage: 'Credit card',
  },
  paymentInformation: {
    id: 'studio.PWbd17',
    defaultMessage: 'Payment information',
  },
  agreement: {
    id: 'studio.PswzdP',
    defaultMessage:
      'I understand that Appsemble has partnered with Stripe, who collects Direct Debits on behalf of Appsemble and confirm that I am the account holder and the only person required to authorize debits from this account.',
  },
  verifyInformation: {
    id: 'studio.AS0mTU',
    defaultMessage: 'Please verify your payment information below.',
  },
  chargeInformation: {
    id: 'studio.7JyZ9a',
    defaultMessage:
      'You will receive two days advance notice of any amount to be debited under this instruction. Payments will show up as "Appsemble" on your bank statement. After you complete the setup, an email confirmation will be sent to {email} within 3 business days.',
  },
  confirmPaymentInformation: {
    id: 'studio.bTJWvP',
    defaultMessage: 'Confirm and pay',
  },
  finish: {
    id: 'studio.2O2sfp',
    defaultMessage: 'Finish',
  },
  expirationDate: {
    defaultMessage: 'New expiration date',
    id: 'studio.IlRvTp',
  },
  subscriptionPlan: {
    defaultMessage: 'Subscription plan',
    id: 'studio.uyaXYC',
  },
  renewalPeriod: {
    defaultMessage: 'Renewal period',
    id: 'studio.HyDbXD',
  },
  email: {
    defaultMessage: 'Email',
    id: 'studio.sy+pv5',
  },
  emailDescription: {
    defaultMessage: 'Email that the invoice and relevant payment updates will be sent to.',
    id: 'studio.Elelf8',
  },
  emailInvalid: {
    id: 'studio.jv0FOj',
    defaultMessage: 'This must be a valid email address',
  },
  vatAmount: {
    defaultMessage: 'VAT',
    id: 'studio.KxG+iy',
  },
  totalPrice: {
    defaultMessage: 'Total price',
    id: 'studio.4VivsY',
  },
  summary: {
    defaultMessage: 'Summary',
    id: 'studio.RrCui3',
  },
  wantedRenewalPeriod: {
    defaultMessage: 'The renewal period you have selected:',
    id: 'studio.MSj+lS',
  },
  reviewDetails: {
    defaultMessage: 'Review details',
    id: 'studio.M5biB9',
  },
  chosenSubscription: {
    defaultMessage: 'Chosen subscription type: ',
    id: 'studio.aaZkF8',
  },
  purchaseSuccessful: {
    defaultMessage: 'Purchase successful',
    id: 'studio.L67/zT',
  },
  purchaseFailed: {
    defaultMessage: 'Purchase failed',
    id: 'studio.6S8k7b',
  },
  purchaseError: {
    defaultMessage:
      'Something went wrong regarding your purchase and payment could not be collected.',
    id: 'studio.ZJUdgS',
  },
  incorrectVatId: {
    defaultMessage: 'Please double check the provided VAT id on "Billing information" page.',
    id: 'studio.sw/YAo',
  },
});
